//src/appsync.js
import Vue from "vue";
import AWSAppSyncClient from "aws-appsync";
import VueApollo from "vue-apollo";
import { getCredentials } from '../src/shared/utils';

const config = {
  url: process.env.VUE_APP_APPSYNC_URL,
  region: 'ap-southeast-2',
  auth: {
    type: 'AMAZON_COGNITO_USER_POOLS',
    jwtToken: async () => (await getCredentials().token ? getCredentials().token : ''),
  }
};
const options = {
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "cache-and-network"
    }
  }
};

const defaultClient = new AWSAppSyncClient(config, options);

const apolloProvider = new VueApollo({ defaultClient });

Vue.use(VueApollo);

export default apolloProvider;
